export default __webpack_public_path__ + "static/media/img-c-00-btn-egt@2x.2cf1dbe2.png";